import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IzvestajOPopunjenostiReklamnihBlokovaComponent } from '../izvestaj-o-popunjenosti-reklamnih-blokova/izvestaj-o-popunjenosti-reklamnih-blokova.component';

@NgModule({
  imports: [CommonModule],
  declarations: [IzvestajOPopunjenostiReklamnihBlokovaComponent],
})
export class IzvestajOPopunjenostiReklamnihBlokovaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-o-popunjenosti-reklamnih-blokova/izvestaj-o-popunjenosti-reklamnih-blokova.module.ts